import React from 'react';

const FaceSurprised = ({ className = "" }) => (
  <svg className={className} width="100" height="100" viewBox="0 0 100 100" fill="none">
    <ellipse cx="50" cy="55" rx="20" ry="25" stroke="currentColor" strokeWidth="2.5" fill="none"/>
    <circle cx="44" cy="50" r="3" fill="currentColor"/>
    <circle cx="56" cy="50" r="3" fill="currentColor"/>
    <circle cx="50" cy="62" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

export default FaceSurprised;